// extracted by mini-css-extract-plugin
module.exports = {"criteria":"password-check-list_criteria__n3MX8","criteriaValid":"password-check-list_criteriaValid___LIpM","criteriaInvalid":"password-check-list_criteriaInvalid__KP2iP"};